import CustomViewActions from "./actions/actions"
import ApiCustomViews from "../../gd/api/custom-view"
import {NavigationButtonPosition, NavigationSectionConfig, NavigationSectionType} from "../navigation/@const"
import NavigationSection from "../navigation/navigation-section"
import {EntityType} from "../../gd/const/item"
import navigation_addCustomViewToNavigation from "../navigation/actions/add-custom-view-to-navigation"
import getViewLocationOptions from "./actions/get-view-location-options"
import getCustomViewDefaultLocation from "./actions/get-default-location"
import {ViewType} from "../../gd/const/views/view-type"
import {getViewSystemType} from "../../gd/const/views/get-view-system-type";
import {MY_WORK_VIEWS, ViewAccess, ViewTypeConfigs} from "../../gd/const/views/view-type-config";
import View from "../view/view";
import ProjectSession from "../project/project-session"
import {BUS_NAVIGATION_CHANGED} from "../../../layout/navigation/@const";
import navigation_unpinAndGoTo from "../../../layout/navigation/actions/unpin-and-goto";
import {PopoverMenuItemType} from "../../gd-components/popover-menu/popover-menu/const";
import Navigation_ButtonGenericDeprecated from "../../../layout/navigation/buttons/generic-section";
import {getNavigationPosition} from "../navigation/functions/get-navigation-position";

const debug = false
// const debug = "CustomView"

export type CustomViewConfig = {
    canDelete       : boolean
    name            : string
    singleton       : boolean
    url             : string
    iconSvg         : string
    // vozmozno chto to eche
    image?          : string
}

export type CustomViewData = {
    id                  : ID
    type                : ViewType
    name                : string
    userId              : ID // owner
    params?             : any
    sharedUsers?        : ID[]
    sharedViewId?       : ID
    settings            : any
    isDynamic?          : boolean
    viewType?           : any // patch for older versions...
    parentProjectId?    : ID
}

export default class CustomView<CustomViewSettingsClass=any> extends View {

    public userId           : ID      // createor of view

    // params
    public params               : any // _.get(data,'params', {}) for params null default object is not set
    private _location           : NavigationSectionType
    public parentProjectId? : ID    // if Custom View is inside the project structure ?


    public settingsLoaded   : boolean = false;      //
    declare settings         : CustomViewSettingsClass    // custom view settings - need lazy load from server
    public access           : ViewAccess            // strange ....

    public _config          : CustomViewConfig      // any  ???


    public sharedUsers      : any
    public sharedViewId?    : string                // I guess this is sharedViewID

    public hasMainMenuInNavigationPanel     : boolean   = false // if true && in NavigationPanel - show it's own main menu
    public mainMenu         : any   = null          // navigation panel static menu component - like my tasks

    public isDynamic        : boolean       // for views created on the run

    constructor(data:CustomViewData) {

        debug && console.log(debug, "constructor() data=", data)

        super(data, data.type , EntityType.CUSTOM_VIEW)

        // this.id             = data.id;
        // this.type           = data.type;
        // this.name           = data.name;


        this.userId         = data.userId      // createor of view

        this.access         = _.get(data,'access', ViewAccess.PRIVATE);
        this.sharedUsers    = data.sharedUsers || []
        this.sharedViewId   = data.sharedViewId

        this.parentProjectId = data.parentProjectId

        // params
        this.params = !_.isNil(data.params) ? data.params : {}; // _.get(data,'params', {}) for params null default object is not set
        this._location = _.get(data,'params.location', getCustomViewDefaultLocation(this.type))


        // settings
        this.settingsLoaded = false;    //
        this.settings = data.settings;  // in future view please use classes

        this.isDynamic = data.isDynamic || false

        // patch
        if (!data.type && data.viewType) this.type = data.viewType;

        // system
        this._config        = ViewTypeConfigs[this.type] as CustomViewConfig

        this.icon           = _.get(this._config, 'icon', 'i5-icon-task')

        // Patch for unsupported views
        if (!this._config) {
            console.error("View ", this.type, "not found in const error #CUSTOMVIEW-23")
            return
        }

        this._init();
    }

    static async initForApp(customViewId?:ID, customViewData?:any):Promise<CustomView|false> {

        if (customViewData) {
            // we have customViewData from config i.e. project
        } else if (customViewId) {
            // no data - need load

            try {
                customViewData = await gd.api.Views.getView(customViewId).promise()
            } catch (e) {
                // no view by ID found...
                return false
            }


        } else {
            throw Error("#9038272 no data no id... hm....")
        }

        const customView = new CustomView(customViewData)

        return customView

    }

    get systemType():ViewType {
        return getViewSystemType(this.type)
    }

    get viewId() {return "view-"+this.id}

    get entityType() { return EntityType.CUSTOM_VIEW }

    _init() {
        // this.canPin = this.location !== 'my-work';
    }

    get actions():CustomViewActions {
        return new CustomViewActions(this)
    }

    get viewType():ViewType {
        return this.type
    }

    get url() {

        if (this.isSingleton) {
            return this._config.url;
        }

        return "v/"+this._config.url+'/'+this.id;
    }

    applyDelta(data:any) {
        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return;

            debug && console.log(debug, "applyDelta key=", key, "value=", value)

            switch (key) {
                case 'params':
                    this[key] = value
                    if (value.location) this._location = value.location
                    break

                default             :
                    // @ts-ignore
                    this[key] = value
                    isChanged = true
            }

            debug && console.log(debug, "this=", this)
        })

        this._init()

        return isChanged
    }

    open() {
        debug && console.log(debug, "open", this.url)
        gd.goTo(this.url);
    }

    openInfo() {
        gd.modal.isOpen && gd.modal.hide(); //if delete or settings modal already visible

        if (this.parentProjectId) {
            gd.navigation.goToProject(this.parentProjectId, '/info')
        } else {
            gd.goTo('v/{0}/{1}/info'.f(ViewTypeConfigs[this.type as ViewType]!.url, this.id))
        }
    }


    _initSettings(data:any) {
        debug && console.log(debug, "._initSettings", data)

        this.settingsLoaded = true
        this.settings       = data.settings
        this.access         = data.access
        this.sharedUsers    = data.sharedUsers
        this.sharedViewId   = data.sharedViewId

    }

    loadSettings() {
        // do not load settings for dynamic views
        if (this.settingsLoaded || this.isDynamic) return true;

        const loadSettings = new Promise((resolve, reject) => {

            gd.api.Views.getSettings(this.id).done((response:any) => {
                this._initSettings(response);
                resolve(true)
            })

        })

        return loadSettings;

    }

    async loadSettingsAsync() {
        if (this.settingsLoaded) return true;

        const response = await gd.api.Views.getSettings(this.id).promise()

        this._initSettings(response);
    }

    // update query
    save() {

        debug && console.log(debug, "save()")

        if (this._location) {
            this.params.location = this.location
        }

        this._init();

        return gd.api.Views.update(this.id, this.name, this.params, this.access, this.sharedUsers, this.sharedViewId, this.settings);
    }

    async saveSettings() {
        const response : any = await ApiCustomViews.updateNew(this.id, {
            settings: this.settings
        }).promise()

        return response
    }

    async saveParams() {
        const response : any = await ApiCustomViews.updateNew(this.id, {
            params: this.params
        }).promise()

        return response
    }

    // check if this view is open right now
    get isOpen():boolean {
        const fragment : string = gd.router.history.fragment || '';

        if (this.isSingleton) {
            return _.startsWith(fragment, this.url)
        } else {
            // why not just start withs ?
            return _.startsWith(fragment, 'v/') && fragment.includes(this.id);
        }
    }

    get locationOptions():Option[] {
        return getViewLocationOptions(this.type)
    }

    // Getters & Setters

    get location():NavigationSectionType {

        const userSettingsLocation = gd.user.settings.navigation.getViewLocation(this.id)
        if (userSettingsLocation) {
            // console.orange("based on user settings")
            return userSettingsLocation
        }

        // if in project structure then it should be projects section
        if (this.inProjectStructure) {

            this._location = NavigationSectionType.PROJECTS

            // if (gd.spaces.projects.enabled) {
            //     this._location = NavigationSectionType.PROJECTS
            // } else {
            //     this._location = NavigationSectionType.HOME
            // }

        } else if (this.isSharedWithMe) { // if shared with menu -> send to home
            this._location = NavigationSectionType.HOME
        } else {
            // Patch old location to new
            if (this._location === NavigationSectionType.NAVIGATION)    this._location = NavigationSectionType.NAVIGATION_PANEL
            if (this._location === NavigationSectionType.HOME_MENU)     this._location = NavigationSectionType.HOME
            if (this._location === NavigationSectionType.TOOLS)         this._location = NavigationSectionType.HOME
        }

        if (this._location === NavigationSectionType.PROJECTS && !gd.spaces.projects.enabled) {
            this._location = NavigationSectionType.HOME
        }

        // console.brown("based on view")

        return this._location
    }

    set location(viewLocation: NavigationSectionType) {

        debug && console.log(debug, "View", this.name, "set location ", viewLocation)

        gd.user.settings.navigation.setViewLocation(this.id, viewLocation)
        gd.user.settings.save()

        switch (viewLocation) {

            case NavigationSectionType.NAVIGATION_PANEL:
                navigation_addCustomViewToNavigation(this, NavigationButtonPosition.TOP)
                return

            case NavigationSectionType.MORE:
                navigation_addCustomViewToNavigation(this, NavigationButtonPosition.MORE)
                return

            default:
                debug && console.log(debug, "location: add custom view to", viewLocation, "default case...")

                gd.layout.navigation.reset()
                gd.layout.navigation.reRender("CustomView on location set")
                gd.layout.currentMenu?.reRender()

                // apply app specific navigation behaviour
                const app: any = gd.getMainApp()
                if (app?.updateMainNavigation) app.updateMainNavigation()

                gd.bus.triggerEvent(BUS_NAVIGATION_CHANGED)

                break

        }
    }


    // Dynamic Properties

    get isSharedWithMe():boolean {
        return this.userId !== gd.session.me.id
    }

    get isSingleton():boolean {
        return this._config['singleton'] === true
    }

    get canChangeLocation(): boolean {
        return true
    }

    get canDelete():boolean {
        return this._config['canDelete'] !== false;
    }

    get canEdit():boolean {

        if (this.inProjectStructure) {
            const project: ProjectSession = gd.session.projects.get(this.parentProjectId)!
            return project.acl.hasFullAccess
        }

        if (this.isSharedWithMe) return false

        return true
    }

    get canBeShared():boolean {
        return !this.isSingleton && !MY_WORK_VIEWS.includes(this.type)
    }

    get canShare():boolean {
        return !this.isSharedWithMe && !MY_WORK_VIEWS.includes(this.type)
    }

    get canPin():boolean {
        return this.location !== 'my-work'
    }

    // this is in constructor now
    // get icon():string {
    //     return _.get(this._config, 'icon', 'i5-icon-task')
    // }

    // get iconSvg() {
    //
    // }

    // get showMenuInMainMenu():boolean {
    //     return this.location === NavigationSectionType.NAVIGATION_PANEL && gd.layout.menuState === LayoutMenuState.STATIC
    // }

    get inProjectStructure():boolean {
        return !!this.parentProjectId
    }

    get inNavigationPanel():boolean {
        return this.location === NavigationSectionType.NAVIGATION_PANEL || this.location === NavigationSectionType.MORE
    }

    get inHomeMenu():boolean {
        return this.location === NavigationSectionType.HOME ||  this.location === NavigationSectionType.HOME_MENU
    }

    get navigationSection() : NavigationSection {

        switch (this.location) {

            case NavigationSectionType.MORE:
            case NavigationSectionType.NAVIGATION_PANEL:
                return gd.navigationStructure.get("view-"+this.id)

            case NavigationSectionType.PROJECTS:
                return gd.navigationStructure.get(NavigationSectionType.PROJECTS)

            case NavigationSectionType.TOOLS:
                return gd.navigationStructure.get(NavigationSectionType.TOOLS)

            case NavigationSectionType.HOME:
            case NavigationSectionType.HOME_MENU:
                return gd.navigationStructure.get(NavigationSectionType.HOME)

            default:
                console.red("location "+ this.location+" is unknown...")
                return gd.navigationStructure.defaultSection
        }
    }

    get projectIcon() {
        switch (this.type) {
            case ViewType.PROJECT_BOARD                 : return 'view-board'
            case ViewType.PROJECT_LIST                  : return 'view-list'
            case ViewType.PROJECT_CALENDAR              : return 'view-calendar'
            case ViewType.CUSTOM_VIEW_EVENTS_SUMMARY    : return 'view-events-summary'
            case ViewType.CUSTOM_VIEW_EXPENSES          : return 'view-expenses'
            case ViewType.PROJECT_GANTT                 : return 'view-gantt'
            case ViewType.PROJECT_WORKLOAD              : return 'view-workload'
            case ViewType.PROJECT_TIMELINE              : return 'view-timeline'
            case ViewType.PROJECT_ACTIVITY              : return 'view-activity'
            case ViewType.CUSTOM_VIEW_WHATS_DONE        : return 'view-what-is-done'
            case ViewType.CUSTOM_VIEW_PASTDUE           : return 'view-pastdue'
            case ViewType.CUSTOM_VIEW_PRIORITIES        : return 'view-priorities'
            case ViewType.CUSTOM_VIEW_ACTION_REQUIRED   : return 'view-action-required'
            case ViewType.CUSTOM_VIEW_TASKS_BY_USER     : return 'view-tasks-by-user'
            case ViewType.CUSTOM_VIEW_DASHBOARD         : return 'view-dashboard'

            case ViewType.PROJECTS_PORTFOLIO            : return 'view-portfolio'
            case ViewType.PROJECTS_PROJECTS_LIST        : return 'view-projects-list'

            case ViewType.PROJECT_TABLE                 :
            default                                     : return 'view-table'
        }

    }

    get updateCurrentPresetIsAllowed() {
        if (this.inProjectStructure) {
            return gd.projectViews.project.acl.hasFullAccess
        } else {
            return this.userId === gd.user.id
        }
    }

    toNavigationSection():NavigationSection {

        let config : NavigationSectionConfig = {
            id              : this.viewId,
            customView      : this,
            icon            : this.icon,
            iconActive      : this.icon,
            hint            : this.name,
            renderComponent : Navigation_ButtonGenericDeprecated,
            type            : NavigationSectionType.CUSTOM_VIEW,
            menuComponent   : this.mainMenu,
            onClick         : this.mainMenu ? gd.navigationStructure.onClickDefault : gd.navigationStructure.onClickCustomView,
            position        : getNavigationPosition("view-"+this.id as NavigationSectionType, NavigationButtonPosition.TOP),
        }

        debug && console.log(debug, 'config', config, gd.user.settings.navigation.buttonPositions)

        const navigationSection = new NavigationSection(config)
        return navigationSection
    }

    // used to build more options in navigation button
    moreOptions() : Option[] {

        const onEdit = () => {
            // props.hideHint && props.hideHint()
            gd.modal.isOpen && gd.modal.hide() //if delete or settings modal already visible

            gd.goTo('v/{0}/{1}/info'.f(ViewTypeConfigs[this.type as ViewType]!.url, this.id))
        }

        const onDelete = () => {
            // props.hideHint && props.hideHint()
            this.actions.delete()
        }

        const setDisplayIn = async (displayIn:NavigationSectionType) => {
            this.location = displayIn

            if ([
                NavigationSectionType.HOME_MENU,
                NavigationSectionType.PROJECTS,
                NavigationSectionType.TOOLS,
            ].includes(displayIn) && gd.layout.navigation.state.currentSection?.id === "view-"+this.id) {
                await navigation_unpinAndGoTo(displayIn,this.url)
            }

        }

        const canDelete = this.canDelete && (!this.isSharedWithMe || this.isSingleton || this.canEdit)

        const moreOptions : Option[] = [{
            label       : "Info",
            icon        : "ii5-information",
            disabled    : !this.canEdit,
            onClick     : onEdit
        }, {
            label       : "Delete",
            icon        : "i5-trash-alt",
            onClick     : onDelete,
            disabled    : !canDelete
        }, {
            type        : PopoverMenuItemType.SEPARATOR
        }, {
            type        : PopoverMenuItemType.HEADER,
            label       : 'Display In:'
        }]

        // add display options
        _.map(this.locationOptions, (option:Option) => {
            option              = _.clone(option)    // because we modify it below
            option.isSelected   = option.value === this.location
            option.onClick      = () => setDisplayIn(option.value as NavigationSectionType)
            moreOptions.push(option)
        })

        return moreOptions

    }


    toJSON():JSONObject {

        const settings: any = this.settings

        return {
            id                  : this.id,
            companyId           : gd.companyId,
            type                : this.type,
            name                : this.name,
            userId              : this.userId,
            params              : this.params,
            _location           : this._location,
            settings            : settings.toJSON ? settings.toJSON() : settings,
            access              : this.access,
            sharedUsers         : this.sharedUsers,
            sharedViewId        : this.sharedViewId || null
        }
    }


}


